module.exports = __webpack_public_path__ + "static/earth_blue_textured.79790694.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Intro/earth_blue_textured.png
// module id = 509
// module chunks = 35783957827783